import styled from 'styled-components';

import { spacing, fontSizes, body2, colors, smallShadow } from 'ui/theme';

export const SettingsPlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing.x10} 0;
  margin-bottom: ${spacing.double};
  background-color: ${colors.white};
  border-radius: ${spacing.half};
  ${smallShadow}
`;

export const SettingsPlaceholderTitle = styled.div`
  margin: ${spacing.half} 0;
  font-size: ${fontSizes.s20};
  color: ${colors.textPrimary};
`;

export const SettingsPlaceholderDescription = styled.div`
  ${body2}
  color: ${colors.textSecondary};
`;
